import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { useMyLibrary } from "~/modules/main/hooks/use-my-library/use-my-library";

import { usePromptDetails } from "~/modules/main/hooks/use-prompt-details/use-prompt-details";

import { usePublicPromptDetails } from "~/modules/main/hooks/use-public-prompt-details/use-public-prompt-details";

import { useExplore } from "~/modules/main/hooks/use-explore/use-explore";

import { useTagManagement } from "~/modules/main/hooks/use-tag-management/use-tag-management";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    useMyLibrary: useMyLibrary,

    usePromptDetails: usePromptDetails,

    usePublicPromptDetails: usePublicPromptDetails,

    useExplore: useExplore,

    useTagManagement: useTagManagement,

} as DomainHooksRegistryInterface;